import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import logo from "../assets/images/logo-win-white.svg";
import '../assets/css/login.css';
import { validateLogin, getToken } from '../Services/loginClient';
import { Eye, EyeOff } from 'lucide-react'; // Add this import at the top

const Login = () => {
    const [pharmacyID, setPharmacyID] = useState('');
    const [userID, setUserID] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false); // Add this state
    const navigate = useNavigate();

    const handleLogin = async () => {
        if (!pharmacyID || !userID || !password) {
            toast.error("Mandatory fields* Pharmacy ID, User ID, Password");
            return;
        }

        try {
            const result = await validateLogin(pharmacyID, userID, password, "");
            const tokenResp = await getToken(pharmacyID, userID, password, "");

            // Defensive check for token response
            // const token = tokenResp?.data;
            // if (!token) {
            //     toast.error("Incorrect Pharmacy ID or Username or Password.");
            //     return;
            // }

            // Only store non-sensitive user info
            if (result?.data?.success || result?.success) {
                toast.success("Login successful!");
                localStorage.setItem("user", JSON.stringify(result.data ?? result));
                navigate("/home");
            } else if (result?.data?.changePassword || result?.changePassword) {
                const msg = result?.data?.message ?? result?.message;
                toast.success(msg || "Password change required.");
                window.open('/#/change-password', '_blank');
            } else {
                const msg = result?.data?.message ?? result?.message ?? "Login failed!";
                toast.error(msg);
            }
        } catch (err) {
            const msg =
                err?.response?.data?.message ||
                err?.message ||
                "Network error (likely CORS).";
            toast.error(msg);
            console.error("Login error:", err);
        }
    };

    const handleSSOClick = async () => {
        // Optionally: Call your backend API to log activity
        // await fetch('/api/log-activity', { method: 'POST', body: JSON.stringify({ activity: 'SSO Link Click' }) });

        // Redirect to SSO URL
        window.location.href =
            "https://www.winfertilitysso.com/auth_request.aspx?MODE=PROD&CONTRACT=CIGNA&STATE=" +
            encodeURIComponent("https://www.winfertilitypharmacy.com/#/ResponsePage");
    };

    return (
        <div className='body-style'>
            <div className="login-page ">
                <Toaster position="top-right" />
                <header className="top-logo">
                    <img src={logo} alt="Logo" />
                </header>
                <div className="login-container full-width">
                    <div className="login-form" >
                        <h1>Login</h1>
                        <form>
                            <div>
                                <label htmlFor="pharmacyID">Pharmacy ID<span className="required-star">*</span></label>
                                <input
                                    type="text"
                                    id="pharmacyID"
                                    value={pharmacyID}
                                    onChange={(e) => setPharmacyID(e.target.value)}
                                    placeholder="Enter Your Pharmacy ID"
                                />
                            </div>
                            <div>
                                <label htmlFor="userID">User ID<span className="required-star">*</span></label>
                                <input
                                    type="text"
                                    id="userID"
                                    value={userID}
                                    onChange={(e) => setUserID(e.target.value)}
                                    placeholder="Enter Your User ID"
                                />
                            </div>
                            <div>
                                <label htmlFor="password">Password<span className="required-star">*</span></label>
                                <div className="password-input-wrapper">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onKeyDown={e => { if (e.key === 'Enter') handleLogin(); }}
                                        placeholder="Enter Your Password"
                                        className="password-input"
                                    />
                                    <span
                                        className="password-toggle-icon"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                    </span>
                                </div>
                            </div>
                            <button type="button" onClick={handleLogin}
                                onKeyDown={e => { if (e.key === 'Enter') handleLogin(); }}>Login</button>
                            <div style={{ marginTop: '10px', textAlign: 'center', fontSize: '14px', lineHeight: '1.3' }}>
                                <p style={{ margin: '4px 0' }}>
                                    Need help logging In? Contact Technical Support&nbsp;
                                    <a
                                        href="#/contact-us"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#ec008c', textDecoration: 'none', fontWeight: '500' }}
                                    >
                                        here
                                    </a>
                                </p>
                                <p style={{ margin: '4px 0' }}>
                                    Cigna Users&nbsp;
                                    <a
                                        onClick={handleSSOClick}
                                        style={{ color: '#ec008c', cursor: 'pointer', textDecoration: 'underline', fontWeight: '500' }}
                                    >
                                        here
                                    </a>
                                </p>
                                <a
                                    href="#/forgot-password"
                                    target='_blank'
                                    rel="noopener noreferrer"
                                    style={{ display: 'block', marginTop: '6px', textDecoration: 'underline', color: '#333', fontWeight: '600' }}
                                >
                                    Forgot Password?
                                </a>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
